import { defineStore } from 'pinia'

export const useFormErrorsStore = defineStore('formErrors', () => {
  const errors: any = ref([])

  const lookups: any = reactive({})
  return {
    errors,
    lookups,
  }
})
